import { DecimalPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

import {
  getProperRoundingRule,
  isNumber,
  replaceCommaWithDot,
} from '../../../@store/_common/number-type-helpers';

@Pipe({ name: 'decimalPipe' })
export class DecimalPipeWrapper extends DecimalPipe implements PipeTransform {
  public transform(value: number | string, digitsInfo?: string, locale?: string): any {
    if (!isNumber(value)) {
      return value;
    }

    if (typeof value === 'string') {
      value = replaceCommaWithDot(value);
    }

    return super.transform(
      value,
      digitsInfo ?? getProperRoundingRule(value),
      locale ?? null // we dont have to provide locale here, we provide LOCALE_ID globally in class DynamicLocaleId
    );
  }
}
